import api from '@/utils/api';


export const getAllEvents = async () => {
  try {
    const response = await api.get('/events-calendar?limit=100');
    return response;
  } catch (error) {
    console.error('Error fetching events:', error);
    throw error;
  }
};

export const addEvent = async (params: unknown) => {
  const response = await api.req({
    url: `/events-calendar`,
    method: api.Method.POST,
    body: params,
  });
  return response;
};

export const DeleteEventp = async (uuid: string) => {
  const response = await api.req({
    url: `/events-calendar/uuid/${uuid}`,
    method: api.Method.DELETE,
  });
  return response;
};

export const updateEvent = async (uuid: string, params: unknown) => {
  const response = await api.req({
    url: `/events-calendar/uuid/${uuid}`,
    method: api.Method.PUT,
    body: params,
  });
  return response;
};

export const getLeadEvents = async (leadUuid: string) => {
  try {
    const response = await api.get(`/events-calendar/lead/${leadUuid}`);
    return response;
  } catch (error: any) {
    // Return empty array structure when endpoint doesn't exist
    return { data: [] };
  }
};

/**
 * Get events with role-based access control
 * The backend /personal endpoint now respects user's role:
 * - Super Admin / System Admin (lead_scope='all'): See ALL client events
 * - Team Manager / Team Lead (lead_scope='team'): See own + team members' events
 * - Sales Rep (lead_scope='assigned'): See only own events
 * - Department (lead_scope='department'): See department events
 */
export const getPersonalEvents = async (dateFrom?: string, dateTo?: string) => {
  try {
    const params = new URLSearchParams({ limit: '500' });
    if (dateFrom) params.set('date_from', dateFrom);
    if (dateTo) params.set('date_to', dateTo);
    const response = await api.get(`/events-calendar/personal?${params.toString()}`);
    return response;
  } catch (error) {
    console.error('Error fetching events:', error);
    throw error;
  }
};
